export const MedibankCSPConfig = {
  cspConfiguration: {
    partner: 'medibank',
    partnerTitle: 'Medibank Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'medibank-sit-petportal-auth.petsure.com.au',
        appClientId: 'ecSkLyHW6lupx3Nycg8ctOY6FYaVHVxP',
        cspMfaUrl: 'https://medibank-sit-petportal.au.auth0.com/mfa/'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'medibank-uat-petportal-auth.petsure.com.au',
        appClientId: 'biaJrhKSn2Vsw3RUqVC2u8qFmL2wfxQN',
        cspMfaUrl: 'https://medibank-uat-petportal.au.auth0.com/mfa/'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'medibank-preprod-petportal-auth.petsure.com.au',
        appClientId: 'XXXX',
        cspMfaUrl: 'https://medibank-preprod-petportal.au.auth0.com/mfa/'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'medibank-petportal-auth.petsure.com.au',
        appClientId: 'XXXX',
        cspMfaUrl: 'https://medibank-petportal.au.auth0.com/mfa/'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'medibank.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'medibank.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'medibank.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'medibank.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      prod: 'https://www.medibank.com.au/content/dam/retail/travel-pet-life-assets/Pet%20Insurance%20Launch_Website%20Tile_Transparent_500x500.png.thumb.1440.1440.png'
    },
    footerLogo: {
      prod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp-assets-petsure-preprod/images/footer/footer_bw_pia.png',
        imageTitle: 'Pet Insurance Australia',
        imageTitleDescription: 'Pet Insurance Australia'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: false
  }
};
